import { NavigationMenuItem } from './types';

const FFD_ONLY_AFFILIATE_MENU_IDS = new Set([
  'affiliates-online-offline-access',
]);

export const filterNavigationMenuItemByProject = (
  item: NavigationMenuItem,
  isFfd: boolean
): NavigationMenuItem => {
  if (!item.children) {
    return item;
  }

  const children = item.children
    .filter(
      (child) => isFfd || !FFD_ONLY_AFFILIATE_MENU_IDS.has(child.id ?? '')
    )
    .map((child) => filterNavigationMenuItemByProject(child, isFfd));

  if (!children.length) {
    return {
      ...item,
      type: 'item',
      children: undefined,
    };
  }

  return { ...item, children };
};
